<div class="d-flex align-items-center px-6 py-4 admin-header">
  <h5 class="h5 bold flex-grow-1">{{ 'users.titles.users' | translate }}</h5>
  <gcc-search-input #search="gccSearchInput"></gcc-search-input>
  <button type="button" class="btn btn-primary ml-4 btn-add" (click)="handleAddUserModal()">
    {{ 'common.buttons.add' | translate }}
  </button>
</div>
<gcc-grid [dataSource]="dataSource" [searchInput]="search" trackByProp="id" class="p-4">
  <gcc-empty-state-wrapper
    class="flex-grow-1"
    [heading]="'common.messages.no_records' | translate"
  ></gcc-empty-state-wrapper>
</gcc-grid>

<ng-template #actions let-item="item">
  <span
    [tooltip]="'users.messages.delete_system_user' | translate"
    [delay]="1000"
    [isDisabled]="!item.isSystem"
    placement="left"
    container="body"
    triggers="click"
  >
    <button
      type="button"
      [disabled]="item.isSystem"
      class="btn btn-icon"
      (click)="handleDeleteUser(item); $event.stopPropagation()"
    >
      <i class="icon icon-delete"></i>
    </button>
  </span>
</ng-template>
